import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import React from "react";
import PropTypes from "prop-types";
import Ellipses from "../Ellipses/index.js";
import PageLink from "../PageLink/index.js";
import { DESKTOP, DESKTOP_NEXT_ELLIPSES, DESKTOP_PREV_ELLIPSES, MOBILE, MOBILE_NEXT_ELLIPSES, MOBILE_PREV_ELLIPSES, shouldHideInMobile } from "../../utils/index.js";
import generatePageLinkConfig from "../../utils/generatePageLinkConfig.js";
import styles from "./styles.css";
var getClassName = function getClassName(_ref) {
  var activePage = _ref.activePage,
    hide = _ref.hide,
    page = _ref.page;
  var className;
  if (activePage === page) {
    className = styles.activePage;
  } else if (hide === MOBILE) {
    className = styles.numberedLinkHiddenInMobile;
  } else {
    className = styles["default"];
  }
  return className;
};
var NumberedPagesAndEllipses = function NumberedPagesAndEllipses(_ref2) {
  var renderLink = _ref2.renderLink,
    activePage = _ref2.activePage,
    onPageChange = _ref2.onPageChange,
    totalPageCount = _ref2.totalPageCount;
  var numberedPageAndEllipsesConfig = generatePageLinkConfig(activePage, totalPageCount);

  // render elements based on config
  return _mapInstanceProperty(numberedPageAndEllipsesConfig).call(numberedPageAndEllipsesConfig, function (link) {
    var isDesktopEllipses = link === DESKTOP_NEXT_ELLIPSES || link === DESKTOP_PREV_ELLIPSES;
    var isMobileEllipses = link === MOBILE_NEXT_ELLIPSES || link === MOBILE_PREV_ELLIPSES;
    if (isDesktopEllipses) {
      return /*#__PURE__*/React.createElement(Ellipses, {
        key: link,
        "data-ellipses-type": link,
        hide: MOBILE
      });
    }
    if (isMobileEllipses) {
      return /*#__PURE__*/React.createElement(Ellipses, {
        key: link,
        "data-ellipses-type": link,
        hide: DESKTOP
      });
    }

    /** ASSUME link is a number from here on */
    // includes strings that can be coerced into numbers, e.g. "5"

    var elementClass = getClassName({
      activePage: activePage,
      page: link,
      hide: shouldHideInMobile(activePage, link, totalPageCount) && MOBILE
    });
    return /*#__PURE__*/React.createElement("li", {
      key: link,
      className: elementClass
    }, /*#__PURE__*/React.createElement(PageLink, {
      renderLink: renderLink,
      activePage: activePage,
      linkText: link,
      onPageChange: onPageChange,
      totalPageCount: totalPageCount,
      page: link
    }));
  });
};
process.env.NODE_ENV !== "production" ? NumberedPagesAndEllipses.propTypes = {
  activePage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  totalPageCount: PropTypes.number.isRequired
} : void 0;
export default NumberedPagesAndEllipses;